const GraphQLLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      className="skill-icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.39 96.8521L13.79 94.1951L65.04 5.43408L69.637 8.09008L18.39 96.8521Z"
        fill="#00E96C"
      />
      <path d="M12.7334 87.105H115.229V92.415H12.7334V87.105Z" fill="#00E96C" />
      <path
        d="M66.0306 119.688L14.7656 90.09L17.4216 85.488L68.6876 115.09L66.0306 119.688ZM110.566 42.543L59.3006 12.941L61.9566 8.34399L113.223 37.941L110.566 42.543Z"
        fill="#00E96C"
      />
      <path
        d="M17.4334 42.523L14.7764 37.922L66.0464 8.32397L68.7024 12.922L17.4334 42.523Z"
        fill="#00E96C"
      />
      <path
        d="M109.621 96.8521L58.3748 8.09008L62.9728 5.43408L114.223 94.1951L109.621 96.8521ZM16.7998 34.3981H22.1128V93.6021H16.8008L16.7998 34.3981Z"
        fill="#00E96C"
      />
      <path
        d="M105.887 34.3979H111.199V93.6019H105.887V34.3979Z"
        fill="#00E96C"
      />
      <path
        d="M65.1286 117.441L62.8086 113.421L107.395 87.676L109.715 91.696L65.1286 117.441Z"
        fill="#00E96C"
      />
      <path
        d="M118.238 95.328C115.168 100.672 108.32 102.496 102.977 99.426C97.6329 96.352 95.8089 89.504 98.8789 84.16C101.953 78.816 108.801 76.992 114.145 80.063C119.52 83.168 121.344 89.984 118.238 95.328ZM29.0899 43.84C26.0159 49.184 19.1679 51.008 13.8239 47.937C8.47985 44.863 6.65585 38.016 9.72685 32.672C12.8009 27.328 19.6479 25.504 24.9919 28.574C30.3359 31.68 32.1599 38.496 29.0899 43.84ZM9.76185 95.328C6.68685 89.984 8.51185 83.168 13.8549 80.062C19.1989 76.992 26.0149 78.816 29.1209 84.16C32.1909 89.504 30.3669 96.32 25.0229 99.426C19.6479 102.496 12.8319 100.672 9.76185 95.328ZM98.9099 43.84C95.8399 38.496 97.6639 31.68 103.008 28.574C108.352 25.504 115.168 27.328 118.273 32.672C121.343 38.016 119.52 44.832 114.176 47.938C108.832 51.008 101.984 49.184 98.9099 43.84ZM63.9999 126.656C62.5329 126.657 61.08 126.369 59.7245 125.809C58.3689 125.248 57.1373 124.425 56.0999 123.388C55.0626 122.351 54.2401 121.119 53.6793 119.763C53.1185 118.408 52.8305 116.955 52.8319 115.488C52.8305 114.021 53.1185 112.568 53.6793 111.213C54.2401 109.857 55.0626 108.625 56.0999 107.588C57.1373 106.551 58.3689 105.728 59.7245 105.167C61.08 104.607 62.5329 104.319 63.9999 104.32C65.4668 104.319 66.9197 104.607 68.2752 105.167C69.6308 105.728 70.8624 106.551 71.8998 107.588C72.9371 108.625 73.7596 109.857 74.3204 111.213C74.8812 112.568 75.1692 114.021 75.1679 115.488C75.1679 121.633 70.1758 126.656 63.9999 126.656ZM63.9999 23.68C62.5329 23.6813 61.08 23.3933 59.7245 22.8326C58.3689 22.2718 57.1373 21.4492 56.0999 20.4119C55.0626 19.3746 54.2401 18.1429 53.6793 16.7874C53.1185 15.4318 52.8305 13.979 52.8319 12.512C52.8305 11.045 53.1185 9.59219 53.6793 8.23663C54.2401 6.88108 55.0626 5.6494 56.0999 4.6121C57.1373 3.57479 58.3689 2.75221 59.7245 2.19143C61.08 1.63065 62.5329 1.34268 63.9999 1.344C65.4668 1.34268 66.9197 1.63065 68.2752 2.19143C69.6308 2.75221 70.8624 3.57479 71.8998 4.6121C72.9371 5.6494 73.7596 6.88108 74.3204 8.23663C74.8812 9.59219 75.1692 11.045 75.1679 12.512C75.1692 13.979 74.8812 15.4318 74.3204 16.7874C73.7596 18.1429 72.9371 19.3746 71.8998 20.4119C70.8624 21.4492 69.6308 22.2718 68.2752 22.8326C66.9197 23.3933 65.4668 23.6813 63.9999 23.68Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default GraphQLLogo;
